import { FormControl, FormLabel, Input, Textarea } from '@chakra-ui/react'
import type { TaskFieldModuleProps } from '../types'

export function TextFieldModule({ field, formData, onFormDataChange, isReadOnly }: TaskFieldModuleProps) {
  const value = String(formData[field.key] ?? '')

  return (
    <FormControl isRequired={field.required}>
      <FormLabel fontSize="sm">{field.label}</FormLabel>
      <Input
        size="sm"
        value={value}
        isReadOnly={isReadOnly}
        onChange={(e) => onFormDataChange(field.key, e.target.value)}
      />
    </FormControl>
  )
}

export function TextareaFieldModule({ field, formData, onFormDataChange, isReadOnly }: TaskFieldModuleProps) {
  const value = String(formData[field.key] ?? '')

  return (
    <FormControl isRequired={field.required}>
      <FormLabel fontSize="sm">{field.label}</FormLabel>
      <Textarea
        size="sm"
        rows={4}
        value={value}
        isReadOnly={isReadOnly}
        onChange={(e) => onFormDataChange(field.key, e.target.value)}
      />
    </FormControl>
  )
}

export function ExternalLinkFieldModule({ field, formData, onFormDataChange, isReadOnly }: TaskFieldModuleProps) {
  const value = String(formData[field.key] ?? '')

  return (
    <FormControl isRequired={field.required}>
      <FormLabel fontSize="sm">{field.label}</FormLabel>
      <Input
        size="sm"
        type="url"
        placeholder="https://"
        value={value}
        isReadOnly={isReadOnly}
        onChange={(e) => onFormDataChange(field.key, e.target.value)}
      />
    </FormControl>
  )
}
